export default self => {
  var index;
  var inputs = document.getElementsByTagName("input");
  var selects = document.getElementsByTagName("select");
  var textareas = document.getElementsByTagName("textarea");
  var itemList = [...inputs, ...selects, ...textareas];
  var objstr = {};
  for (index = 0; index < itemList.length; ++index) {
    if (itemList[index].name) {
      objstr[itemList[index].name] = "";
    }
  }
  self.setState(objstr);
  self.setState({ Id: 0, isActive: true, isEditMode: false });
};



// WEBPACK FOOTER //
// ./src/utils/clearForm.js